import { useMutation } from '@apollo/client';

import { SubmitFormMutation, SubmitFormMutationVariables } from '../../../__generated__/graphql';
import submitFormMutation from '../submitFormMutation.gql';

export const useSubmitForm = () =>
  useMutation<SubmitFormMutation, SubmitFormMutationVariables>(submitFormMutation);
